import { useSelector } from 'react-redux';
import { Button } from '@integration/alexandria-ui';
import {
  ArrowContainer,
  CaseInput,
  FollowMyCaseTitle,
  InputContainer,
  InvalidCaseNumber,
  MarkdownContainerCaseOpening,
  Wrapper,
} from './CaseOpeningStyled';
import { Banner, BannerType } from '@integration/alexandria-ui';
import Markdown from 'components/Markdown';
import Arrow from 'components/Icons/ArrowCaseOpening';
import { Main } from 'globalStyles/Containers';
import { useCaseOpening, useDTOptions } from './caseOpeningHook';
import { backgroundHomeUrlSelector } from 'redux/selectors/config';
import { useUnavailabilityBanner } from 'hooks/unavailability-hooks';

export const CaseOpening = () => {
  const {
    t,
    showCaseCreationButton,
    openCase,
    showFollowMyCase,
    caseReferenceHandler,
    error,
    gotToCase,
  } = useCaseOpening();
  const { dtOptions } = useDTOptions();
  const backgroundImage = useSelector(backgroundHomeUrlSelector);
  const { showUnavailabilityBanner, title, message } =
    useUnavailabilityBanner();

  return (
    <Wrapper backgroundImage={backgroundImage}>
      <Main>
        <MarkdownContainerCaseOpening data-testid={'intro-page'}>
          <Markdown
            text={t(
              !showUnavailabilityBanner
                ? 'home-content-markdown'
                : 'home-unavailability-content-markdown',
              {
                decision_tree_options: dtOptions,
              },
            )}
          ></Markdown>
        </MarkdownContainerCaseOpening>
        {showCaseCreationButton && (
          <Button data-testid="open-new-case_button" onClick={openCase}>
            {t(
              !showUnavailabilityBanner
                ? 'home-create_case_button'
                : 'home-unavailability-create-case_button',
            )}
          </Button>
        )}
        {showUnavailabilityBanner && (
          <Banner
            type={BannerType.INFO}
            containerClassName="home-unavailability-banner"
            shouldShowCloseIcon={false}
            title={<Markdown text={title} />}
            text={<Markdown text={message} />}
          />
        )}
        {showFollowMyCase && (
          <>
            <FollowMyCaseTitle>
              {t('home-follow_my_case_title')}
            </FollowMyCaseTitle>
            <InputContainer>
              <CaseInput
                placeholder={t('home-follow_my_case_placeholder')}
                onChange={caseReferenceHandler}
                error={error}
              />
              <ArrowContainer onClick={gotToCase}>
                <Arrow />
              </ArrowContainer>
            </InputContainer>
            {error && (
              <InvalidCaseNumber>
                {t('home-follow_my_case_error')}
              </InvalidCaseNumber>
            )}
          </>
        )}
      </Main>
    </Wrapper>
  );
};

export default CaseOpening;
